import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { NotificationManager } from "react-notifications";
import { ConsumidoresFinalesApi } from "../api/ConsumidoresFinalesApi";
import { FiltrosConsumidoresFinales } from "./FiltrosConsumidoresFinales";
import { ConsumidoresFinalesTable } from "./ConsumidoresFinalesTable";
import Paginacion from "../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../Utils/LoadMask/LoadMask";
import { useDebounce } from "../../../../Utils/Hooks/useDebounce";
import { getErrorFromResponse } from "../../../../../../utility/utils";

const STORAGE_KEY = "consumidores_finales_state";

export const ConsumidoresFinales = () => {
    const savedState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const filtros = savedState && savedState.filtros ? savedState.filtros : {};

    const { control, watch } = useForm({
        defaultValues: {
            search: filtros.search || "",
        },
    });

    const [consumidoresFinales, setConsumidoresFinales] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(
        savedState.pagina || 1,
    );
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const search = watch("search");
    const debouncedSearch = useDebounce(search, 500);

    const { getConsumidoresFinales, deleteConsumidorFinal, cargando } =
        ConsumidoresFinalesApi();

    const GetConsumidoresFinales = async () => {
        try {
            const params = {
                page: paginaSeleccionada,
            };

            if (debouncedSearch) params.search = debouncedSearch;

            const response = await getConsumidoresFinales(params);
            setConsumidoresFinales(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener los consumidores finales",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setConsumidoresFinales([]);
            setCantidadResultados(0);
        }
    };

    const EliminarConsumidorFinal = async (id) => {
        try {
            await deleteConsumidorFinal(id);
            NotificationManager.success(
                "Consumidor final eliminado correctamente",
                "Éxito",
                3000,
            );
            GetConsumidoresFinales();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar el consumidor final",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        GetConsumidoresFinales();
    }, [debouncedSearch, paginaSeleccionada]);

    useEffect(() => {
        const stateToSave = {
            filtros: {
                search: debouncedSearch,
            },
            pagina: paginaSeleccionada,
        };

        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    }, [debouncedSearch, paginaSeleccionada]);

    return (
        <div className="consumidores-finales__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <div className="consumidores-finales__table-header">
                        <FiltrosConsumidoresFinales
                            control={control}
                            onRefresh={() => {
                                GetConsumidoresFinales();
                            }}
                            resetPage={() => setPaginaSeleccionada(1)}
                            searchPlaceholder={"Consumidor final"}
                        />
                        <Link to="/clientes/consumidores-finales/crear">
                            <button className="btn btn-primary">
                                Crear consumidor final
                            </button>
                        </Link>
                    </div>

                    <ConsumidoresFinalesTable
                        consumidoresFinales={consumidoresFinales}
                        EliminarConsumidorFinal={EliminarConsumidorFinal}
                    />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
